import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ui-product-price-advantage',
  imports: [],
  templateUrl: './product-price-advantage.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-price-advantage.component.scss',
})
export class ProductPriceAdvantageComponent {
  public small: InputSignal<boolean> = input(false);
}
